export default __webpack_public_path__ + "static/Saira-Bold-4bd1e97f00350ea1cbce273f18cba689.woff2";